export const europe_country_code = [
  'DE', 'ES', 'GB', 'IT', 'FR', 'GR', 'NL', 'DK', 'LV', 'RO', 'LU', 'LT', 'MT', 'BE', 'BG', 'SE', 'SK', 'SI', 'IE', 'EE', 'AT', 'CZ', 'HR', 'CY', 'PT', 'PL', 'FI', 'HU', 'IS', 'NO', 'MK', 'ME', 'MD', 'BA', 'RS', 'AM', 'AZ', 'AL', 'GE', 'XK', 'CH'
];

export const asia_country_code = [
  "KR", "JP", "CN", "HK", "TW", "IN", "ID", "MY", "SG", "TH",
  "VN", "PH", "BD", "PK", "LK", "NP", "KZ", "UZ", "IR", "IQ",
  "SA", "AE", "QA", "KW", "BH", "JO", "IL", "MN", "MM", "LA",
  "KH", "AF", "GE", "AM", "AZ", "TM", "TL"
]

export const arab_country_code = [
  "SA", "AE", "QA", "KW", "BH", "OM", "YE", "JO", "IQ", "SY",
  "LB", "PS", "EG", "SD", "DZ", "MA", "TN", "LY", "MR", "DJ",
  "SO", "KM"
];

export const americas_country_code = [
  "US", "CA", "MX", "GT", "HN", "SV", "NI", "CR", "PA",
  "CU", "DO", "HT", "JM", "TT", "BS", "BB", "BZ", "AG",
  "LC", "GD", "KN", "VC", "DM", "BR", "AR", "CO", "PE",
  "VE", "CL", "EC", "BO", "PY", "UY", "GY", "SR", "GF"
];

export const countryCodesWithTerms = ['KR', 'TH', 'DZ', 'JO', 'KW', 'QA', 'SA', 'AE', 'BH', 'IQ', 'LB', 'OM', 'TN', 'DJ', 'EG', 'MR', 'SD', 'YE', 'SY', 'LY', 'PS', 'CN', 'HK', 'TW', 'JP', 'AO', 'CV', 'CO', 'BR', 'MX', 'AR', 'CL', 'CR', 'DO', 'GT',
  'BO', 'EC', 'SV', 'HN', 'PA', 'PE', 'VE', 'NI', 'PY', 'PR', 'UY', 'AT', 'FR', 'DE', 'LU', 'CH', 'LI', 'MA', 'SO', 'ST', 'GW', 'ES', 'GB', 'IT', 'GR', 'NL', 'DK', 'LV', 'RO', 'LT', 'MT', 'BE', 'BG', 'SE', 'SK', 'SI', 'IE', 'EE', 'CZ', 'HR',
  'CY', 'PT', 'PL', 'FI', 'HU', 'IS', 'NO', 'MK', 'ME', 'MD', 'BA', 'RS', 'AM', 'AZ', 'AL', 'GE', 'XK', 'US']

export const uploadImageMaxWidth = 1400;

export const eNetworkCode = {
  ok: 'S0000',
  notExistUser: 'E7003',
  sessionExpiration: 'E6001',
  noPermission: 'E7001',
  simultaneousConnection: 'E7006'
};

export const eBoardType = {
  BETA:'beta',
  COMMUNITY: 'community',
  OPINION: 'opinion',
  NOTICE: 'notice'
};

export const eSessionKeys = {
  COUNTRY_CODE: 'countryCd',
  DEVICE_LANGUAGE_TYPE: 'empDeviceLanguageType',
  DEVICE_LANGUAGE: 'empDeviceLanguage',
  TOKEN: 'token',
  LANGUAGE: 'language',
  USER_SELECT_LANGUAGE: 'userSelectLanguage',
  USER_COUNTRY_CODE: 'userCountryCode',
  COMMUNITY_NO: 'communityNo',
  WEB_OS_KEY: 'webOsKey',
  USER: 'user',
  PAGE_INFO: 'pageInfo',
  DEVICE_INFO: 'info',
  LOGIN_DATA: 'loginData',
  DEVICE_ID: 'deviceId',
  IS_CP: 'isCP',
  SERVER_TYPE: 'serverType',
  WEB_OS_VERSION: 'webOsVersion',
  WEB_OS_GROUP: 'webOS_group'
};